import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-infrastructure',
  templateUrl: './cloud-infrastructure.component.html',
  styleUrls: ['./cloud-infrastructure.component.css']
})
export class CloudInfrastructureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}